import React from 'react';
import { Route, Switch } from 'react-router-dom';
import List from './List';
import Show from './Show';
import { PlanBillingProvider } from './context';
import { RoutesProvider } from './context/routesContext';
import { showPlanBilling } from '../../config/routes';
import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';

function PlanBilling() {
  return (
    <PlanBillingProvider>
      <RoutesProvider>
        <Switch>
          <Route
            exact
            path={showPlanBilling.spec}
            render={(props) => (
              <>
                <Can I="show" a="PlanBillings">
                  {() => <Show {...props} />}
                </Can>
                <Can not I="show" a="PlanBillings">
                  {() => <NotPermissionPage />}
                </Can>
              </>
            )}
          />
          <Route
            render={(props) => (
              <>
                <Can I="list" a="PlanBillings">
                  {() => <List {...props} />}
                </Can>
                <Can not I="list" a="PlanBillings">
                  {() => <NotPermissionPage />}
                </Can>
              </>
            )}
          />
        </Switch>
      </RoutesProvider>
    </PlanBillingProvider>
  );
}
export default React.memo(PlanBilling);
